import styled from 'styled-components';

export const Card = styled.div`
  border-color: ${(props) => props.theme.$gray400};
  border-radius: 8px 8px 0 0;

  .biddings-header {
    background: ${(props) => props.theme.$gray200};
    border-color: ${(props) => props.theme.$gray400};
    border-radius: 8px 8px 0 0;
    padding: 1rem;
  }

  th,
  td {
    padding: 1rem;
    vertical-align: middle;
  }

  thead th {
    border-top: 0;
    border-bottom: 1px solid ${(props) => props.theme.$gray400};
  }

  .description-cell {
    width: 100%;
    max-width: 0;
    min-width: 200px;
  }
`;
